module.exports = __webpack_public_path__ + "files/ea0fdecc6c082e6abcaf75425998af02.png";